import axios from 'axios';
import toggleToast from './messaging';
import { retrieveItem } from './helpers';

export const BASE_URL =
  window._env_?.API_SERVER_URL || process.env.REACT_APP_API_SERVER_URL;

const axiosRequest = () => {
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
      'content-type': 'application/json',
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      const authToken = config.headers['Authorization'];
      if (!authToken) {
        const savedAuthToken = await retrieveItem('hp_auth_token');
        config.headers['Authorization'] = `Bearer ${savedAuthToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => {
      const {
        data: { status, displayMessage },
      } = response;
      if (status === 'success' && displayMessage) {
        toggleToast(displayMessage, 'success');
      }
      return response;
    },
    (error) => {
      console.log('::::axiosRequest, error:', error, error.response);
      const {
        response: {
          data: { displayMessage },
        },
      } = error;
      if (error.response && error.response.status === 401) {
        window.location.href =
          window._env_?.AUTH_APP_URL ||
          process.env.REACT_APP_AUTH_APP_URL ||
          '';
      }
      if (displayMessage) {
        toggleToast(displayMessage, 'error');
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export { axiosRequest };
